webpackJsonp([28],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _entry = __webpack_require__(632);
	
	var _entry2 = _interopRequireDefault(_entry);
	
	var _ofsPayload = __webpack_require__(355);
	
	var _ofsPayload2 = _interopRequireDefault(_ofsPayload);
	
	var entry = new _entry2['default'](_ofsPayload2['default']);
	
	if (true) {
	  entry.render(document);
	}

/***/ },

/***/ 632:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ofsAppsCoreEntry = __webpack_require__(450);
	
	var _ofsAppsCoreEntry2 = _interopRequireDefault(_ofsAppsCoreEntry);
	
	var _Carousel = __webpack_require__(633);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _ofsUtilsTrackerTracker = __webpack_require__(166);
	
	var _ofsUtilsTrackerTracker2 = _interopRequireDefault(_ofsUtilsTrackerTracker);
	
	function displayHeaderSearch($headerSearch, width) {
	  if (width > 640) {
	    $headerSearch.addClass('ofs-HeaderSearch--is-visible').data('open', true);
	  } else {
	    $headerSearch.removeClass('ofs-HeaderSearch--is-visible').data('open', false);
	  }
	}
	
	var EntryPoint = (function (_BaseEntryPoint) {
	  _inherits(EntryPoint, _BaseEntryPoint);
	
	  function EntryPoint() {
	    _classCallCheck(this, EntryPoint);
	
	    _get(Object.getPrototypeOf(EntryPoint.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(EntryPoint, [{
	    key: 'renderToDocument',
	    value: function renderToDocument(document) {
	      var carousel;
	
	      _get(Object.getPrototypeOf(EntryPoint.prototype), 'renderToDocument', this).call(this, document);
	      _ofsUtilsTrackerTracker2['default'].homePageView();
	
	      function initCarousel() {
	        if ((0, _jquery2['default'])(window).width() > 480) {
	          if (!carousel) {
	            carousel = new _Carousel2['default']((0, _jquery2['default'])('.carousel-container'));
	          }
	        } else {
	          if (carousel) {
	            carousel.destroy();
	            carousel = null;
	          }
	        }
	      }
	      var $headerSearch = (0, _jquery2['default'])('.ofs-HeaderSearch');
	
	      // determine whether to show header quicksearch on load
	      displayHeaderSearch($headerSearch, window.innerWidth);
	
	      window.addEventListener('resize', function (event) {
	        var windowWidth = event.target.innerWidth;
	        displayHeaderSearch($headerSearch, windowWidth);
	        initCarousel();
	      });
	
	      initCarousel();
	    }
	  }]);
	
	  return EntryPoint;
	})(_ofsAppsCoreEntry2['default']);
	
	exports['default'] = EntryPoint;
	module.exports = exports['default'];

/***/ },

/***/ 633:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var Carousel = (function () {
	  function Carousel($el) {
	    _classCallCheck(this, Carousel);
	
	    this.animationInterval = 5000;
	    this.animationDuration = 700;
	    this.$el = $el;
	    this.$spots = $el.find('.spots');
	    this.$slideList = $el.find('.slide-list');
	    this.$slides = $el.find('.slide');
	    this.numSlides = this.$slides.length;
	    this.$next = $el.find('.next');
	    this.$prev = $el.find('.prev');
	    this.$nextMask = $el.find('.mask-right');
	    this.$prevMask = $el.find('.mask-left');
	    this.timer = null;
	    this.touchEnabled = "ontouchstart" in document.documentElement;
	    this.supportsTransitions = _jquery2['default'].support.transition;
	
	    this.$el.on("mouseenter.ofs-carousel", this.onMouseEnter.bind(this));
	    this.$el.on("mouseleave.ofs-carousel", this.onMouseLeave.bind(this));
	
	    $el.find('img').on('dragstart', function (event) {
	      event.preventDefault();
	    });
	
	    this.setTimer();
	    this.buildSpots();
	
	    this.$slides.first().addClass("active");
	    this.$spots.find("li").first().addClass("active");
	    this.currentIndex = 0;
	
	    this.resetPositions();
	    this.bind();
	
	    if (this.touchEnabled) {
	      this.$next.hide();
	      this.$prev.hide();
	    }
	    this.firefoxHack();
	  }
	
	  _createClass(Carousel, [{
	    key: 'onMouseEnter',
	    value: function onMouseEnter() {
	      this.clearTimer();
	    }
	  }, {
	    key: 'onMouseLeave',
	    value: function onMouseLeave() {
	      this.setTimer();
	    }
	  }, {
	    key: 'buildSpots',
	    value: function buildSpots() {
	      var _this = this;
	
	      this.$slides.each(function () {
	        _this.$spots.append("<li>");
	      });
	    }
	  }, {
	    key: 'setTimer',
	    value: function setTimer() {
	      if (!this.timer) {
	        this.timer = setInterval(this.scroll.bind(this, 1), this.animationInterval);
	      }
	    }
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.clearTimer();
	      this.unbind();
	      this.$el.off("mouseenter.ofs-carousel");
	      this.$el.off("mouseleave.ofs-carousel");
	      this.resetPositions();
	      this.$spots.empty();
	      this.$next.hide();
	      this.$prev.hide();
	
	      this.$slides.css({
	        left: 0,
	        display: 'block',
	        position: ''
	      });
	    }
	  }, {
	    key: 'bind',
	    value: function bind() {
	      this.$next.on("click.ofs-carousel", this.scroll.bind(this, 1));
	      this.$next.on("mouseenter.ofs-carousel.tease", this.tease.bind(this, 1));
	      this.$next.on("mouseleave.ofs-carousel.tease", this.revert.bind(this));
	      this.$prev.on("click.ofs-carousel", this.scroll.bind(this, -1));
	      this.$prev.on("mouseenter.ofs-carousel.tease", this.tease.bind(this, -1));
	      this.$prev.on("mouseleave.ofs-carousel.tease", this.revert.bind(this));
	      this.$nextMask.on("click.ofs-carousel", this.scroll.bind(this, 1));
	      this.$prevMask.on("click.ofs-carousel", this.scroll.bind(this, -1));
	      this.$nextMask.on("mouseenter.ofs-carousel.tease", this.tease.bind(this, 1));
	      this.$prevMask.on("mouseenter.ofs-carousel.tease", this.tease.bind(this, -1));
	      this.$nextMask.on("mouseleave.ofs-carousel.tease", this.revert.bind(this));
	      this.$prevMask.on("mouseleave.ofs-carousel.tease", this.revert.bind(this));
	      this.$spots.on("click.ofs-carousel", 'li', this.scrollViaSpots.bind(this));
	      this.$slideList.on("movestart.ofs-carousel", this.dragStart.bind(this));
	      this.$slideList.on("move.ofs-carousel", this.dragSlides.bind(this));
	      this.$slideList.on("swipeabort.ofs-carousel", this.revert.bind(this));
	      this.$slideList.on("swipeleft.ofs-carousel", { threshold: 0.1 }, this.scrollViaSwipe.bind(this, 1));
	      this.$slideList.on("swiperight.ofs-carousel", { threshold: 0.1 }, this.scrollViaSwipe.bind(this, -1));
	    }
	  }, {
	    key: 'unbind',
	    value: function unbind() {
	      this.$next.off("click.ofs-carousel");
	      this.$next.off("mouseenter.ofs-carousel.tease");
	      this.$next.off("mouseleave.ofs-carousel.tease");
	      this.$prev.off("click.ofs-carousel");
	      this.$prev.off("mouseenter.ofs-carousel.tease");
	      this.$prev.off("mouseleave.ofs-carousel.tease");
	      this.$nextMask.off("click.ofs-carousel");
	      this.$prevMask.off("click.ofs-carousel");
	      this.$nextMask.off("mouseenter.ofs-carousel.tease");
	      this.$prevMask.off("mouseenter.ofs-carousel.tease");
	      this.$nextMask.off("mouseleave.ofs-carousel.tease");
	      this.$prevMask.off("mouseleave.ofs-carousel.tease");
	      this.$spots.off("click.ofs-carousel", 'li');
	      this.$slideList.off("movestart.ofs-carousel");
	      this.$slideList.off("move.ofs-carousel");
	      this.$slideList.off("swipeabort.ofs-carousel");
	      this.$slideList.off("swipeleft.ofs-carousel");
	      this.$slideList.off("swiperight.ofs-carousel");
	    }
	  }, {
	    key: 'disableClick',
	    value: function disableClick() {
	      this.$el.on('click.ofs-carousel.disable-click', function (event) {
	        event.preventDefault();
	      });
	    }
	  }, {
	    key: 'enableClick',
	    value: function enableClick() {
	      this.$el.off('click.ofs-carousel.disable-click');
	    }
	  }, {
	    key: 'resetPositions',
	    value: function resetPositions() {
	      this.$slides.each((function (index, el) {
	        var $slide = (0, _jquery2['default'])(el);
	
	        if ($slide.hasClass('active')) {
	          $slide.css({
	            "left": 0,
	            'z-index': 2
	          }).show();
	        } else if (index === this.getPrevIndex()) {
	          $slide.css({
	            'left': '-100%',
	            'z-index': 1
	          }).show();
	        } else if (index === this.getNextIndex()) {
	          $slide.css({
	            'left': '100%',
	            'z-index': 1
	          }).show();
	        } else {
	          $slide.css('z-index', 0).hide();
	        }
	      }).bind(this));
	      this.enableClick();
	    }
	  }, {
	    key: 'setNextPeekLeft',
	    value: function setNextPeekLeft($slide) {
	      $slide.css({ left: '-200%' }).show();
	    }
	  }, {
	    key: 'setNextPeekRight',
	    value: function setNextPeekRight($slide) {
	      $slide.css({ left: '200%' }).show();
	    }
	  }, {
	    key: 'getNextIndex',
	    value: function getNextIndex() {
	      /*
	       * Returns the index of the next slide in the list,
	       * loops round to the start, so if the currentIndex is
	       * the last slide, the next is the first.
	       */
	      if (this.currentIndex < this.numSlides - 1) {
	        return this.currentIndex + 1;
	      }
	      return 0;
	    }
	  }, {
	    key: 'getPrevIndex',
	    value: function getPrevIndex() {
	      /*
	       * Returns the index of the previous slide in the list,
	       * loops round to the end, so if the currentIndex is
	       * the first slide, the previous is the last.
	       */
	      if (this.currentIndex > 0) {
	        return this.currentIndex - 1;
	      }
	      return this.numSlides - 1;
	    }
	  }, {
	    key: 'setUpcomingActive',
	    value: function setUpcomingActive(nextIndex) {
	      var activeSlide = this.$slides.filter(".active");
	      var activeSpot = this.$spots.find(".active");
	
	      if (nextIndex === this.getNextIndex()) {
	        // Going forwards
	        if (nextIndex === this.numSlides - 1) {
	          this.setNextPeekRight(this.$slides.first());
	        } else if (nextIndex === 0) {
	          this.setNextPeekRight(this.$slides.eq(1));
	        } else {
	          this.setNextPeekRight(this.$slides.eq(nextIndex + 1));
	        }
	      } else {
	        // Going backwards
	        if (nextIndex === 0) {
	          this.setNextPeekLeft(this.$slides.last());
	        } else {
	          this.setNextPeekLeft(this.$slides.eq(nextIndex - 1));
	        }
	      }
	      activeSlide.removeClass("active");
	      activeSpot.removeClass("active");
	
	      var nextSlide = this.$slides.eq(nextIndex);
	
	      var currentZIndex = activeSlide.css('z-index');
	      var nextZIndex = nextSlide.css('z-index');
	
	      // Swap z-indexes;
	      nextSlide.css('z-index', currentZIndex);
	      activeSlide.css('z-index', nextZIndex);
	
	      nextSlide.addClass('active');
	      this.$spots.find('li').eq(nextIndex).addClass("active");
	    }
	  }, {
	    key: 'transitionCallback',
	    value: function transitionCallback(offset) {
	      this.resetPositions();
	
	      if (offset > 0) {
	        offset--;
	      } else if (offset < 0) {
	        offset++;
	      }
	      this.$slideList.css({ "left": 0 });
	
	      if (offset) {
	        this.scroll(offset);
	      } else {
	        this.bind();
	        if ((0, _jquery2['default'])('.' + this.$el.attr('class') + ':hover').length === 0) {
	          this.setTimer();
	        }
	      }
	    }
	  }, {
	    key: 'tease',
	    value: function tease(offset) {
	      var transitionX = '2.5%';
	      this.clearTimer();
	
	      if (offset > 0) {
	        transitionX = '-' + transitionX;
	      }
	
	      if (!this.supportsTransitions) {
	        this.$slideList.stop().animate({ "left": transitionX }, 200);
	      } else {
	        this.$slideList.stop().transition({ left: transitionX }, 200);
	      }
	    }
	  }, {
	    key: 'scroll',
	    value: function scroll(offset) {
	      var transitionX = '100%';
	      // Let's disable events for the duration of the transition
	      this.unbind();
	      this.disableClick();
	
	      if (offset > 0) {
	        transitionX = '-' + transitionX;
	        this.setUpcomingActive(this.getNextIndex());
	        this.currentIndex = this.getNextIndex();
	      } else {
	        this.setUpcomingActive(this.getPrevIndex());
	        this.currentIndex = this.getPrevIndex();
	      }
	
	      if (!this.supportsTransitions) {
	        this.$slideList.animate({ "left": transitionX }, this.animationDuration / Math.abs(offset), this.transitionCallback.bind(this, offset));
	      } else {
	        this.$slideList.transition({ left: transitionX }, this.animationDuration / Math.abs(offset), this.transitionCallback.bind(this, offset));
	      }
	    }
	  }, {
	    key: 'scrollViaSwipe',
	    value: function scrollViaSwipe(offset) {
	      this.scroll(offset);
	    }
	  }, {
	    key: 'scrollViaSpots',
	    value: function scrollViaSpots(event) {
	      var clickedSpot = (0, _jquery2['default'])(event.target);
	      var offset = clickedSpot.index() - this.currentIndex;
	
	      // If we're on the first or last slides and we click the other, take a shortcut.
	      if (offset === this.numSlides - 1) {
	        offset = -1;
	      } else if (offset === -(this.numSlides - 1)) {
	        offset = 1;
	      }
	      this.scroll(offset);
	    }
	  }, {
	    key: 'reverted',
	    value: function reverted() {
	      if ((0, _jquery2['default'])('.' + this.$el.attr('class') + ':hover').length === 0) {
	        this.setTimer();
	      }
	      this.enableClick();
	    }
	  }, {
	    key: 'revert',
	    value: function revert() {
	      if (!this.supportsTransitions) {
	        this.$slideList.stop().animate({ "left": 0 }, 200, this.reverted.bind(this));
	      } else {
	        this.$slideList.stop().transition({ "left": 0 }, 200, this.reverted.bind(this));
	      }
	    }
	  }, {
	    key: 'dragStart',
	    value: function dragStart(event) {
	      /*
	       * Do nothing with predominantly vertical events
	       */
	      this.clearTimer();
	      this.disableClick();
	
	      if (event.distX > event.distY && event.distX < -event.distY || event.distX < event.distY && event.distX > -event.distY) {
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'dragSlides',
	    value: function dragSlides(event) {
	      var left = 100 * event.distX / this.$slides.width() + '%';
	
	      this.$slideList.css({
	        "left": left
	      });
	    }
	
	    /**
	     * HACK FOR FIREFOX
	     *
	     * Problem:
	     *  On initial page load the images in the slide to the left of the first
	     *  slide don't show.
	     *
	     * Theory:
	     *  Due to image loading optimization the browser does it does not load
	     *  images into memory that it thinks are not visible. The slide that doesn't
	     *  have images is the last element in the slide list and so could be
	     *  assumed to not be visible if its absolute positioning is not taken into
	     *  account.
	     *
	     * Hack:
	     *  Set the css position of the last slide to relative to force a redraw of
	     *  the slide and show the images. Then wait till the next animation frame
	     *  to set the position back to absolute so that it is back to the way it
	     *  was.
	     */
	  }, {
	    key: 'firefoxHack',
	    value: function firefoxHack() {
	      var $lastSlide = this.$slides.eq(this.$slides.length - 1);
	      $lastSlide.css('position', 'relative');
	      $lastSlide.css('position'); // DOM read to force a repaint
	      $lastSlide.css('position', 'absolute');
	    }
	  }]);
	
	  return Carousel;
	})();
	
	exports['default'] = Carousel;
	module.exports = exports['default'];

/***/ }

});


/** WEBPACK FOOTER **
 ** apps/homepage.js
 **/